import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { initialLanguage } from './languagePolicy'

import ptBR from './locales/pt-BR.json'
import enUS from './locales/en-US.json'
import esES from './locales/es-ES.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      'en-US': { translation: enUS },
      'es-ES': { translation: esES }
    },
    lng: initialLanguage(),
    supportedLngs: ['pt-BR', 'en-US', 'es-ES'],
    fallbackLng: 'pt-BR',
    load: 'currentOnly',
    interpolation: {
      escapeValue: false
    }
  })

const updateDocumentLanguage = (language: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = language
}
i18n.on('languageChanged', updateDocumentLanguage)
updateDocumentLanguage(i18n.resolvedLanguage ?? i18n.language)

export default i18n
